module.exports = __webpack_public_path__ + "img/introductionToStatistics.30a93a11.jpg";